export const apiKeysKeys = {
  all: [{ module: 'apiKeys' }] as const,
  lists: () => [{ ...apiKeysKeys.all[0], scope: 'list' }] as const,
  list: (organizationId: string) => [{ ...apiKeysKeys.lists()[0], organizationId }] as const,
};
